const uzCyrl = {
  login: {
    subtitle: 'Мижоз кабинети',
    title: 'Кириш',
    server: 'Сервер',
    serverPlaceholder: 'ташкилот-номи',
    checking: 'Текширилмоқда...',
    notFound: 'Ташкилот топилмади',
    phone: 'Телефон',
    phonePlaceholder: '90 123 45 67',
    password: 'Парол',
    submit: 'Кириш',
    submitting: 'Кирилмоқда...',
  },
  catalog: {
    searchPlaceholder: 'Маҳсулот қидириш...',
    allFolders: 'Барчаси',
    notFound: 'Топилмади',
    empty: 'Бу папка бўш',
    noPrice: 'Нархи йўқ',
    addToCart: "Қўшиш",
    chooseUnit: "Бирлик танлаш",
    selected: "танланди",
    done: "Тайёр",
    doneRemovesAll: "Барчасини 0 қилсангиз, саватдан олиб ташланади",
  },
  cart: {
    title: 'Сават',
    empty: 'Сават бўш',
    goCatalog: 'Каталогга ўтиш',
    myOrders: 'Буюртмаларим',
    notePlaceholder: 'Изоҳ (ихтиёрий)',
    total: 'Жами',
    submit: 'Буюртма бериш',
    submitting: 'Юборилмоқда...',
    orderSent: 'Буюртма №{number} юборилди',
    orderError: 'Буюртма юборишда хато',
  },
  orders: {
    title: 'Буюртмаларим',
    empty: 'Ҳали буюртма йўқ',
  },
  changePassword: {
    title: 'Янги парол ўрнатинг',
    hint: 'Хавфсизлик учун стандарт паролни ўзгартиришингиз керак. Бу фақат бир марта сўралади.',
    newPassword: 'Янги парол',
    confirmPassword: 'Янги паролни такрорланг',
    tooShort: 'Парол камида 4 та белгидан иборат бўлиши керак',
    mismatch: 'Пароллар мос келмади',
    submit: 'Сақлаш',
    submitting: 'Сақланмоқда...',
    success: 'Парол янгиланди',
    error: 'Хато юз берди',
  },
  profile: {
    changePassword: "Паролни ўзгартириш",
    cancel: "Бекор қилиш",
  },
  home: {
    defaultTitle: 'Мижоз кабинети',
    welcome: 'Хуш келибсиз,',
    balance: 'Баланс',
    noBalance: 'Баланс мавжуд эмас',
    weOwe: 'Сизга қарздормиз',
    theyOwe: 'Қарздорлик',
    cashback: 'Кешбек',
    cashbackProgramTitle: 'Кешбек дастури',
    cashbackProgramHint: 'Харид суммаси қанча катта бўлса, шунча кўп фоиз қайтади',
    cashbackCurrentTier: 'Ҳозир шу даражадасиз',
    navHome: 'Бош сахифа',
    navCatalog: 'Каталог',
    navCart: 'Сават',
    navAkt: 'Акт-сверка',
    navProfile: 'Профил',
    logout: 'Чиқиш',
  },
  aktSverka: {
    title: 'Акт-сверка',
    period: 'Давр',
    fromDate: 'Бошланиши',
    toDate: 'Тугаши',
    youOwe: 'Сизнинг қарзингиз',
    theyOwe: 'Ташкилот сизга қарздор',
    noDebt: "Қарздорлик йўқ",
    noTx: "Бу даврда операция йўқ",
    opening: "Бошланғич қолдиқ",
    loadError: 'Юклашда хато',
    itemsEmpty: 'Таркиб мавжуд эмас',
    total: 'Жами',
    close: 'Ёпиш',
    share: 'Улашиш',
    shareTitle: 'Доимий ҳавола',
    shareHint: 'Бу ҳавола/QR код орқали исталган вақт акт-сверкангизни кўриш мумкин — масалан бухгалтерингизга юборишингиз мумкин.',
    copy: 'Нусхалаш',
    copied: 'Нусхаланди',
    qrDownload: 'Юклаб олиш',
    thDate: 'Сана', thDoc: 'Ҳужжат', thDebit: 'Дебет', thCredit: 'Кредит',
    pdfDownload: 'PDF',
  },
  uomNames: {
    pcs: "дона", kg: "килограмм", g: "грамм", t: "тонна", l: "литр", ml: "миллилитр",
    m: "метр", cm: "сантиметр", mm: "миллиметр", "m²": "квадрат метр", "m³": "куб метр", km: "километр",
    pair: "жуфт", roll: "рулон", box: "қути", pack: "пачка", bag: "қоп", set: "тўплам",
    bottle: "шиша", can: "банка", cyl: "баллон", coil: "ғалтак", spool: "ғалтак (spool)", sheet: "лист", bunch: "пачка",
    hr: "соат", min: "дақиқа", day: "кун", week: "ҳафта", month: "ой", year: "йил",
    visit: "ташриф", session: "сеанс", project: "лойиҳа", page: "саҳифа", word: "сўз", trip: "рейс",
  },
};
export default uzCyrl;
